import { EstadoSesion, MotivoAcceso } from './route-profile-access';

export const MENSAJES_ACCESO: Record<MotivoAcceso, { titulo: string; descripcion: string }> = {
  sin_sesion: {
    titulo: 'No hay una sesión activa',
    descripcion: 'Elige una identidad en «Desarrollo local» (arriba a la derecha) para usar la consola.',
  },
  sin_permiso: {
    titulo: 'Acceso restringido',
    descripcion: 'Esta pantalla no está disponible para tu perfil actual. Si la necesitas para tu trabajo, pide a un administrador que revise tu perfil.',
  },
  mfa_pendiente: {
    titulo: 'Verifica tu segundo factor (MFA)',
    descripcion: 'Tu perfil necesita verificar el segundo factor (MFA) para usar esta pantalla. Verifícalo e inténtalo de nuevo.',
  },
  sin_gestor: {
    titulo: 'Tu identidad no está habilitada en el gestor',
    descripcion:
      'No encontramos un usuario activo del gestor para tu identidad, o tu acceso ya no está vigente. Pide a un administrador que lo habilite y vuelve a intentar.',
  },
};

export const MENSAJE_MENU_VACIO: Record<EstadoSesion, string> = {
  activa: 'Sin secciones configuradas',
  sin_sesion: 'Elige una identidad para ver el menú.',
  mfa_pendiente: 'Verifica tu MFA para ver el menú.',
};
